var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-image"},[_c('BaseImage',{attrs:{"LoadLazy":"","alt":_vm.altText,"img-source":_vm.content,"width":_vm.isMobile() ? '350px' : '780px',"height":_vm.isMobile() ? '200px' : '440px',"quality":"90"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }